import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import home from './home';
import search from './search';
import catalogue from './catalogue';
import datail from './datail';
import details from './details';
import user from './user';
import shopcar from './shopcar';


// 新建并暴露store
export default new Vuex.Store({
    modules:{
        home,
        search,
        catalogue,
        datail,
        details,
        user,
        shopcar,
        
    } 
})